// extracted by mini-css-extract-plugin
export default {"link":"TemplateLink_link__1G-xY","template":"TemplateLink_template__QRIKm"};